<script setup lang="ts">
import type { Iteration } from "@/model/session";

defineProps<{ iterations: readonly Iteration[] }>();
</script>

<template>
  {{ $t("general.iterations") }}
  <div v-for="iter in iterations" :key="iter.id" class="shortcut">
    {{ iter.name }}
  </div>
</template>
